import './ListingSequence.scss'
import * as React from 'react'
import { SvgIcon } from '../../../routes/express_list/SvgIcon'

export function ListingSequence() {
  return (
    <div className="listing-sequence-card">
      <div className="drawer-header">
        <SvgIcon path="/assets/icons/listing_sequence_icon.svg" /> Listing Sequence
      </div>
      <div className="centered-label">Auto-Repricing</div>
    </div>
  )
}
